module.exports = __webpack_public_path__ + "static/media/heart2.6dc12370.png";